import { Component, OnInit } from '@angular/core';
import { FrattaleService } from 'src/app/services/frattale.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-daily-hilo',
  standalone: true,
  templateUrl: './daily-hilo.component.html',
  styleUrls: ['./daily-hilo.component.scss'],
  imports: [ReactiveFormsModule, MdbFormsModule, MdbSelectModule,
    MdbTableModule, CommonModule
  ]
})
export class DailyHiloComponent implements OnInit {

  markets: any = []
  dati: any = [];
  headers = ['Day Of Week', 'Market', 'Type', 'Versus', 'Profit', 'Num', 'Profit/Num(PIP)', 'Num. Pos.'];
  tableData: any = [];

  formFiltri: FormGroup = new FormGroup({
    selMarket: new FormControl(null),
    selDayweek: new FormControl(null)
  })

  days: any = [
    { value: 1, label: 'Lunedì' },
    { value: 2, label: 'Martedì' },
    { value: 3, label: 'Mercoledì' },
    { value: 4, label: 'Giovedì' },
    { value: 5, label: 'Venerdì' }
  ]

  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.service.getMarketsSymbols().subscribe((data: any) => {
      this.markets = data['data'];
    })
    this.service.getDailyBang().subscribe((data: any) => {
      console.log(data)
      this.dati = data['data']
      this.dati = this.dati.filter((item: any)=> item.profit>0)
      this.tableData = this.dati
    })
  }

  filtraDati() {
    let mkt = this.formFiltri.get('selMarket')?.value
    let day = this.formFiltri.get('selDayweek')?.value
    console.log(mkt, day)
    let lst = (mkt!='all' && mkt!=null) ? this.dati.filter((item: any) => item.market==mkt) : this.dati
    lst = day>0 ? lst.filter((item: any) => item.dayweek==day) : lst
    this.tableData = lst
  }

  nomeGiorno(id: number) {
    let elem = this.days.find((d:any) => d.value==id)
    return elem ? elem.label : id
  }

}
